export default "__VITE_ASSET__BoEkn9j___"